
import { HTTPClient } from "./Client";

const DocumentosApi = {

    async EmitirCertificadoConclusao(pessoaId, nomeCurso) {
        const response = await HTTPClient.post(`/Documento/EmitirCertificadoConclusao/${pessoaId}/${nomeCurso}`);
        return response.data;
    },

    async EmitirCertificadoMonitoria(pessoaId, horas, nomeCurso) {
        const response = await HTTPClient.post(`/Documento/EmitirCertificadoMonitoria/${pessoaId}/${horas}/${nomeCurso}`);
        return response.data;
    },

    async ObterAlunosSemCertificado(tipoArquivo, turmaId) {
        const response = await HTTPClient.get(`/Pessoa/ListarPessoasSemCertificados/${tipoArquivo}/${turmaId}`);
        return response.data;
    },

    async CarregarDocumento(formData) {
        try {
            const response = await HTTPClient.post(`/Documento/CarregarDocumento`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao Salvar documento:", error);
            throw error;
        }
    },

    async ObterDocumento(pessoaId) {

        const response = await HTTPClient.get(`/Documento/ObterDocumento/${pessoaId}`);

        return response.data;
    },

    async ObterDocumentoPorPaginacao(pagina, titulo, statusDocumentoEnum) {
        var pagina = {

            Pagina: pagina,
            Titulo: titulo,
            StatusDocumentoEnum: Number(statusDocumentoEnum)
        }
        const response = await HTTPClient.post(`/Documento/ListarDocumentoPaginacao/`, pagina);
        return response.data;
    },

    async ObterCertificadosPorPaginacao(pagina, tipo, turmaId) {
        var certificadoRequest = {
            Pagina: pagina,
            TipoArquivo: Number(tipo),
            TurmaId: Number(turmaId)
        }
        const response = await HTTPClient.post(`/Documento/ListarCertificadosPaginacao/`, certificadoRequest);
        return response.data;
    },

    async AtualizarStatus(documentoId, statusDocumentoEnum) {

        var stats = {
            StatusDocumentoEnum: statusDocumentoEnum
        }

        const response = await HTTPClient.put(`/Documento/AtualizarStatus/${documentoId}`, stats);

        return response.data;
    },


    async RemoverDocumento(documentoId) {

        const response = await HTTPClient.put(`/Documento/RemoverDocumento/${documentoId}`);
        return response.data;
    },

    async ListarTipoEnum() {
        const response = await HTTPClient.get(`/Documento/ListarStatusDocumentoTipos`);

        return response.data;
    },
    async ListarStatusEnum() {
        const response = await HTTPClient.get(`/Documento/ListarStatusdocumentos`);
        return response.data;
    },

    async BaixarDocumento(documentoId) {
        const response = await HTTPClient.get(`/Documento/BaixarDocumento/${documentoId}`, {
            responseType: 'blob',
        });
        return response;
    }

}

export default DocumentosApi;